module.exports = __webpack_public_path__ + "img/cf_balance.7a101752.jpg";